"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NinjaKeys = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _lit = require("lit");

var _decorators = require("lit/decorators.js");

var _repeat = require("lit/directives/repeat.js");

var _live = require("lit/directives/live.js");

var _ref = require("lit-html/directives/ref.js");

var _classMap = require("lit/directives/class-map.js");

var _hotkeysJs = _interopRequireDefault(require("hotkeys-js"));

require("./ninja-header.js");

require("./ninja-action.js");

var _ninjaFooter = require("./ninja-footer.js");

var _baseStyles = require("./base-styles.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var NinjaKeys = /*#__PURE__*/function (_LitElement) {
  _inherits(NinjaKeys, _LitElement);

  var _super = _createSuper(NinjaKeys);

  function NinjaKeys() {
    var _this;

    _classCallCheck(this, NinjaKeys);

    _this = _super.apply(this, arguments);
    /**
     * Search placeholder text
     */

    _this.placeholder = 'Type a command or search...';
    /**
     * If true will register all hotkey for all actions
     */

    _this.disableHotkeys = false;
    /**
     * Show or hide breadcrumbs on header
     */

    _this.hideBreadcrumbs = false;
    /**
     * Open or hide shorcut
     */

    _this.openHotkey = 'cmd+k,ctrl+k';
    /**
     * Navigation Up hotkey
     */

    _this.navigationUpHotkey = 'up,shift+tab';
    /**
     * Navigation Down hotkey
     */

    _this.navigationDownHotkey = 'down,tab';
    /**
     * Close hotkey
     */

    _this.closeHotkey = 'esc';
    /**
     * Go back on one level if has parent menu
     */

    _this.goBackHotkey = 'backspace';
    /**
     * Select action and execute handler or open submenu
     */

    _this.selectHotkey = 'enter'; // enter,space

    /**
     * Show or hide breadcrumbs on header
     */

    _this.hotKeysJoinedView = false;
    /**
     * Disable load material icons font on connect
     * If you use custom icons.
     * Set this attribute to prevent load default icons font
     */

    _this.noAutoLoadMdIcons = false;
    /**
     * Array of actions
     */

    _this.data = [];
    /**
     * Show or hide element
     */

    _this.visible = false;
    /**
     * Temproray used for animation effect. TODO: change to animate logic
     */

    _this._bump = true;
    _this._actionMatches = [];
    _this._search = '';
    /**
     * Array of actions in flat structure
     */

    _this._flatData = [];
    _this._headerRef = (0, _ref.createRef)();
    return _this;
  }
  /**
   * Public methods
   */

  /**
   * Show a modal
   */


  _createClass(NinjaKeys, [{
    key: "open",
    value: function open() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this._bump = true;
      this.visible = true;

      this._headerRef.value.focusSearch();

      if (this._actionMatches.length > 0) {
        this._selected = this._actionMatches[0];
      }

      this.setParent(options.parent);
    }
    /**
     * Close modal
     */

  }, {
    key: "close",
    value: function close() {
      this._bump = false;
      this.visible = false;
    }
    /**
     * Navigate to group of actions
     * @param parent id of parent group/action
     */

  }, {
    key: "setParent",
    value: function setParent(parent) {
      if (!parent) {
        this._currentRoot = undefined; // this.breadcrumbs = [];
      } else {
        this._currentRoot = parent;
      }

      this._selected = undefined;
      this._search = '';

      this._headerRef.value.setSearch('');
    }
  }, {
    key: "breadcrumbs",
    get: function get() {
      var _a;

      var path = [];
      var parentAction = (_a = this._selected) === null || _a === void 0 ? void 0 : _a.parent;

      if (parentAction) {
        path.push(parentAction);

        while (parentAction) {
          var action = this._flatData.find(function (a) {
            return a.id === parentAction;
          });

          if (action === null || action === void 0 ? void 0 : action.parent) {
            path.push(action.parent);
          }

          parentAction = action ? action.parent : undefined;
        }
      }

      return path.reverse();
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(NinjaKeys.prototype), "connectedCallback", this).call(this);

      if (!this.noAutoLoadMdIcons) {
        document.fonts.load('24px Material Icons', 'apps').then(function () {});
      }

      this._registerInternalHotkeys();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      _get(_getPrototypeOf(NinjaKeys.prototype), "disconnectedCallback", this).call(this);

      this._unregisterInternalHotkeys();
    }
  }, {
    key: "_flattern",
    value: function _flattern(members, parent) {
      var children = [];

      if (!members) {
        members = [];
      }

      return members.map(function (mem) {
        var alreadyFlatternByUser = mem.children && mem.children.some(function (value) {
          return typeof value == 'string';
        });

        var m = _objectSpread(_objectSpread({}, mem), {}, {
          parent: mem.parent || parent
        });

        if (alreadyFlatternByUser) {
          return m;
        } else {
          if (m.children && m.children.length) {
            parent = mem.id;
            children = [].concat(_toConsumableArray(children), _toConsumableArray(m.children));
          }

          m.children = m.children ? m.children.map(function (c) {
            return c.id;
          }) : [];
          return m;
        }
      }).concat(children.length ? this._flattern(children, parent) : children);
    }
  }, {
    key: "update",
    value: function update(changedProperties) {
      if (changedProperties.has('data') && !this.disableHotkeys) {
        this._flatData = this._flattern(this.data);

        this._flatData.filter(function (action) {
          return !!action.hotkey;
        }).forEach(function (action) {
          (0, _hotkeysJs.default)(action.hotkey, function (event) {
            event.preventDefault();

            if (action.handler) {
              action.handler(action);
            }
          });
        });
      }

      _get(_getPrototypeOf(NinjaKeys.prototype), "update", this).call(this, changedProperties);
    }
  }, {
    key: "_registerInternalHotkeys",
    value: function _registerInternalHotkeys() {
      var _this2 = this;

      if (this.openHotkey) {
        (0, _hotkeysJs.default)(this.openHotkey, function (event) {
          event.preventDefault();
          _this2.visible ? _this2.close() : _this2.open();
        });
      }

      if (this.selectHotkey) {
        (0, _hotkeysJs.default)(this.selectHotkey, function (event) {
          if (!_this2.visible) {
            return;
          }

          event.preventDefault();

          _this2._actionSelected(_this2._actionMatches[_this2._selectedIndex]);
        });
      }

      if (this.goBackHotkey) {
        (0, _hotkeysJs.default)(this.goBackHotkey, function (event) {
          if (!_this2.visible) {
            return;
          }

          if (!_this2._search) {
            event.preventDefault();

            _this2._goBack();
          }
        });
      }

      if (this.navigationDownHotkey) {
        (0, _hotkeysJs.default)(this.navigationDownHotkey, function (event) {
          if (!_this2.visible) {
            return;
          }

          event.preventDefault();

          if (_this2._selectedIndex >= _this2._actionMatches.length - 1) {
            _this2._selected = _this2._actionMatches[0];
          } else {
            _this2._selected = _this2._actionMatches[_this2._selectedIndex + 1];
          }
        });
      }

      if (this.navigationUpHotkey) {
        (0, _hotkeysJs.default)(this.navigationUpHotkey, function (event) {
          if (!_this2.visible) {
            return;
          }

          event.preventDefault();

          if (_this2._selectedIndex === 0) {
            _this2._selected = _this2._actionMatches[_this2._actionMatches.length - 1];
          } else {
            _this2._selected = _this2._actionMatches[_this2._selectedIndex - 1];
          }
        });
      }

      if (this.closeHotkey) {
        (0, _hotkeysJs.default)(this.closeHotkey, function () {
          if (!_this2.visible) {
            return;
          }

          _this2.close();
        });
      }
    }
  }, {
    key: "_unregisterInternalHotkeys",
    value: function _unregisterInternalHotkeys() {
      if (this.openHotkey) {
        _hotkeysJs.default.unbind(this.openHotkey);
      }

      if (this.selectHotkey) {
        _hotkeysJs.default.unbind(this.selectHotkey);
      }

      if (this.goBackHotkey) {
        _hotkeysJs.default.unbind(this.goBackHotkey);
      }

      if (this.navigationDownHotkey) {
        _hotkeysJs.default.unbind(this.navigationDownHotkey);
      }

      if (this.navigationUpHotkey) {
        _hotkeysJs.default.unbind(this.navigationUpHotkey);
      }

      if (this.closeHotkey) {
        _hotkeysJs.default.unbind(this.closeHotkey);
      }
    }
  }, {
    key: "_actionFocused",
    value: function _actionFocused(index, $event) {
      // this.selectedIndex = index;
      this._selected = index;
      $event.target.ensureInView();
    }
  }, {
    key: "_onTransitionEnd",
    value: function _onTransitionEnd() {
      this._bump = false;
    }
  }, {
    key: "_goBack",
    value: function _goBack() {
      var parent = this.breadcrumbs.length > 1 ? this.breadcrumbs[this.breadcrumbs.length - 2] : undefined;
      this.setParent(parent);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var classes = {
        bump: this._bump,
        'modal-content': true
      };
      var menuClasses = {
        visible: this.visible,
        modal: true
      };

      var actionMatches = this._flatData.filter(function (action) {
        var _a;

        var regex = new RegExp(_this3._search, 'gi');
        var matcher = action.title.match(regex) || ((_a = action.keywords) === null || _a === void 0 ? void 0 : _a.match(regex));

        if (!_this3._currentRoot && _this3._search) {
          // global search for items on root
          return matcher;
        }

        return action.parent === _this3._currentRoot && matcher;
      });

      var sections = actionMatches.reduce(function (entryMap, e) {
        return entryMap.set(e.section, [].concat(_toConsumableArray(entryMap.get(e.section) || []), [e]));
      }, new Map());
      this._actionMatches = _toConsumableArray(sections.values()).flat();

      if (this._actionMatches.length > 0 && this._selectedIndex === -1) {
        this._selected = this._actionMatches[0];
      }

      if (this._actionMatches.length === 0) {
        this._selected = undefined;
      }

      var actionsList = function actionsList(actions) {
        return (0, _lit.html)(_templateObject || (_templateObject = _taggedTemplateLiteral([" ", ""])), (0, _repeat.repeat)(actions, function (action) {
          return action.id;
        }, function (action) {
          var _a;

          return (0, _lit.html)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<ninja-action\n            exportparts=\"ninja-action,ninja-selected,ninja-icon\"\n            .selected=", "\n            .hotKeysJoinedView=", "\n            @mouseover=", "\n            @actionsSelected=", "\n            .action=", "\n          ></ninja-action>"])), (0, _live.live)(action.id === ((_a = _this3._selected) === null || _a === void 0 ? void 0 : _a.id)), _this3.hotKeysJoinedView, function (event) {
            return _this3._actionFocused(action, event);
          }, function (event) {
            return _this3._actionSelected(event.detail);
          }, action);
        }));
      };

      var itemTemplates = [];
      sections.forEach(function (actions, section) {
        var header = section ? (0, _lit.html)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<div class=\"group-header\">", "</div>"])), section) : undefined;
        itemTemplates.push((0, _lit.html)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", "", ""])), header, actionsList(actions)));
      });
      return (0, _lit.html)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      <div @click=", " class=", ">\n        <div class=", " @animationend=", ">\n          <ninja-header\n            exportparts=\"ninja-input,ninja-input-wrapper\"\n            ", "\n            .placeholder=", "\n            .hideBreadcrumbs=", "\n            .breadcrumbs=", "\n            @change=", "\n            @setParent=", "\n            @close=", "\n          >\n          </ninja-header>\n          <div class=\"modal-body\">\n            <div class=\"actions-list\" part=\"actions-list\">", "</div>\n          </div>\n          <slot name=\"footer\"> ", " </slot>\n        </div>\n      </div>\n    "])), this._overlayClick, (0, _classMap.classMap)(menuClasses), (0, _classMap.classMap)(classes), this._onTransitionEnd, (0, _ref.ref)(this._headerRef), this.placeholder, this.hideBreadcrumbs, this.breadcrumbs, this._handleInput, function (event) {
        return _this3.setParent(event.detail.parent);
      }, this.close, itemTemplates, _ninjaFooter.footerHtml);
    }
  }, {
    key: "_selectedIndex",
    get: function get() {
      if (!this._selected) {
        return -1;
      }

      return this._actionMatches.indexOf(this._selected);
    }
  }, {
    key: "_actionSelected",
    value: function _actionSelected(action) {
      var _a; // fire selected event even when action is empty/not selected,
      // so possible handle api search for example


      this.dispatchEvent(new CustomEvent('selected', {
        detail: {
          search: this._search,
          action: action
        },
        bubbles: true,
        composed: true
      }));

      if (!action) {
        return;
      }

      if (action.children && ((_a = action.children) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        this._currentRoot = action.id;
        this._search = '';
      }

      this._headerRef.value.setSearch('');

      this._headerRef.value.focusSearch();

      if (action.handler) {
        var result = action.handler(action);

        if (!(result === null || result === void 0 ? void 0 : result.keepOpen)) {
          this.close();
        }
      }

      this._bump = true;
    }
  }, {
    key: "_handleInput",
    value: function () {
      var _handleInput2 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(event) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._search = event.detail.search;
                _context.next = 3;
                return this.updateComplete;

              case 3:
                this.dispatchEvent(new CustomEvent('change', {
                  detail: {
                    search: this._search,
                    actions: this._actionMatches
                  },
                  bubbles: true,
                  composed: true
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _handleInput(_x) {
        return _handleInput2.apply(this, arguments);
      }

      return _handleInput;
    }()
  }, {
    key: "_overlayClick",
    value: function _overlayClick(event) {
      var _a;

      if ((_a = event.target) === null || _a === void 0 ? void 0 : _a.classList.contains('modal')) {
        this.close();
      }
    }
  }]);

  return NinjaKeys;
}(_lit.LitElement);

exports.NinjaKeys = NinjaKeys;
NinjaKeys.styles = [_baseStyles.baseStyles];

__decorate([(0, _decorators.property)({
  type: String
})], NinjaKeys.prototype, "placeholder", void 0);

__decorate([(0, _decorators.property)({
  type: Boolean
})], NinjaKeys.prototype, "disableHotkeys", void 0);

__decorate([(0, _decorators.property)({
  type: Boolean
})], NinjaKeys.prototype, "hideBreadcrumbs", void 0);

__decorate([(0, _decorators.property)()], NinjaKeys.prototype, "openHotkey", void 0);

__decorate([(0, _decorators.property)()], NinjaKeys.prototype, "navigationUpHotkey", void 0);

__decorate([(0, _decorators.property)()], NinjaKeys.prototype, "navigationDownHotkey", void 0);

__decorate([(0, _decorators.property)()], NinjaKeys.prototype, "closeHotkey", void 0);

__decorate([(0, _decorators.property)()], NinjaKeys.prototype, "goBackHotkey", void 0);

__decorate([(0, _decorators.property)()], NinjaKeys.prototype, "selectHotkey", void 0);

__decorate([(0, _decorators.property)({
  type: Boolean
})], NinjaKeys.prototype, "hotKeysJoinedView", void 0);

__decorate([(0, _decorators.property)({
  type: Boolean
})], NinjaKeys.prototype, "noAutoLoadMdIcons", void 0);

__decorate([(0, _decorators.property)({
  type: Array,
  hasChanged: function hasChanged() {
    // Forced to trigger changed event always.
    // Because of a lot of framework pattern wrap object with an Observer, like vue2.
    // That's why object passed to web component always same and no render triggered. Issue #9
    return true;
  }
})], NinjaKeys.prototype, "data", void 0);

__decorate([(0, _decorators.state)()], NinjaKeys.prototype, "visible", void 0);

__decorate([(0, _decorators.state)()], NinjaKeys.prototype, "_bump", void 0);

__decorate([(0, _decorators.state)()], NinjaKeys.prototype, "_actionMatches", void 0);

__decorate([(0, _decorators.state)()], NinjaKeys.prototype, "_search", void 0);

__decorate([(0, _decorators.state)()], NinjaKeys.prototype, "_currentRoot", void 0);

__decorate([(0, _decorators.state)()], NinjaKeys.prototype, "_flatData", void 0);

__decorate([(0, _decorators.state)()], NinjaKeys.prototype, "breadcrumbs", null);

__decorate([(0, _decorators.state)()], NinjaKeys.prototype, "_selected", void 0);

exports.NinjaKeys = NinjaKeys = __decorate([(0, _decorators.customElement)('ninja-keys')], NinjaKeys);